import type { NewsPageType } from '../types';

export function sortNewsByPublishDateDesc(
  newsPages: NewsPageType[],
): NewsPageType[] {
  return [...newsPages].sort((a, b) => {
    const dateA = a.publishDate ? new Date(a.publishDate).getTime() : 0;
    const dateB = b.publishDate ? new Date(b.publishDate).getTime() : 0;
    return dateB - dateA;
  });
}
